import { EntrepreneurAnnounce7FormComponent } from "../../../components/SupportSystem/SupportForm/EntrepreneurAnnounce7FormComponent";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";

export function EntrepreneurAnnounce7FormContainer () {
    const titleName = "ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <EntrepreneurAnnounce7FormComponent/>
            <Footer />
        </div>        
    )
    
}